import { LabeledValue, MediaItem } from '../types/content';

export const caseCartouche: LabeledValue[] = [
  { label: 'Client', value: 'Nébuleuse — Arena Tour' },
  { label: 'Scénographe', value: 'Studio Kinetik' },
  { label: 'Lieu', value: '32 arenas européennes' },
  { label: 'Année', value: '2026' },
];

export const caseTechnical: LabeledValue[] = [
  { label: 'Matériaux', value: 'Acier · polystyrène densifié · résine projetée · bois CNC' },
  { label: 'Machines', value: 'Robot 5 axes · découpe plasma · fraiseuse CNC' },
];

export const caseConstraints: LabeledValue[] = [
  { label: 'Démontage', value: '14 modules' },
  { label: 'Poids', value: '18 kg/m²' },
  { label: 'Réaction au feu', value: 'Classé M1' },
  { label: 'Transport', value: '2 semis calées' },
];

export const caseMedia: MediaItem[] = [
  {
    label: 'Plans 3D',
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/f7f22bf1-b285-4c32-82ed-0de76e5d1f6b.jpg',
    alt: 'Modèle 3D filaire d’une sculpture sur écran',
  },
  {
    label: 'Usinage',
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/95e8faae-67e0-4b7a-aa18-70ec29043b8e.jpg',
    alt: 'Robot 5 axes usinant un bloc de polystyrène',
  },
  {
    label: 'Fabrication',
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/9a1910b6-7b5a-405c-b9f0-af4cd113ad4a.jpg',
    alt: 'Projection de résine en atelier',
  },
  {
    label: 'In situ',
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/4cdd3135-04ce-4446-8e55-acabc85bda6b.jpg',
    alt: 'Décor installé sur une scène d’arena',
  },
];
